export function getValue(aObj: any, propsInString: string) {
    return propsInString.split(".").reduce((acc, prop) => {
        if (acc === undefined) return acc;
        if (acc === null) return undefined;
        return acc[prop];
    }, aObj);
}
